import { Theme } from '@8fig/theme';
import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  dot: {
    height: theme.spacing(1.5),
    width: theme.spacing(1.5),
    borderRadius: '100%',
    backgroundColor: theme.palette.brand.greyMid3,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    '&:hover': {
      cursor: 'pointer',
    },
  },
  activeDot: {
    backgroundColor: theme.palette.brand.greenNature,
  },
}));
